import { API, apiFetch } from "../../../lib/api";
import { buildPublicOrderApiUrl } from "../../../lib/publicCarte";

interface OrderItem {
  wineId: string;
  quantity: number;
}

interface OrderForm {
  nom: string;
  email: string;
  tel: string;
  adresse: string;
  societe: string;
  message: string;
  dateSouhaitee: string;
}

export interface PublicOrderAccess {
  customerHash: string;
  userId?: string;
  carteId?: string;
}

export interface SubmitOrderResult {
  orderText: string;
}

export async function submitOrder(
  items: OrderItem[],
  form: OrderForm,
  maison: string,
  publicOrderAccess?: PublicOrderAccess
): Promise<SubmitOrderResult> {
  const response = publicOrderAccess
    ? await fetch(buildPublicOrderApiUrl(API || "", publicOrderAccess), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ items, form, maison }),
      })
    : await apiFetch("/orders", {
        method: "POST",
        body: JSON.stringify({ items, form, maison }),
      });

  if (!response.ok) {
    const data = await response.json().catch(() => ({ error: "Erreur lors de l'envoi de la commande." }));
    throw new Error(data.error || "Erreur lors de l'envoi de la commande.");
  }

  return response.json();
}